/**
 * 出品区分
 */
export const ListingCategoryConst = 
{
  /**
   * 相対
   */
  PRIVATE: 1,
  /**
   * 通常入札
   */
  BIDDING: 2,
  /**
   * 入札会
   */
  SALE: 3,
} as const;
export type  ListingCategoryType = typeof ListingCategoryConst[keyof typeof ListingCategoryConst];

// 県内・県外の値 
export const PrefTypeConst = {
  INTERNAL: 1,
  EXTERNAL: 2,
} as const;
export type PrefectureType = typeof PrefTypeConst[keyof typeof PrefTypeConst];

// ラベル表示用
export const PrefCategoryLabel = {
  [PrefTypeConst.INTERNAL]: "県内",
  [PrefTypeConst.EXTERNAL]: "県外",
};

// 合体選択肢
export const CombinedCategoryOptions = [
  // { value: `${ListingCategoryConst.PRIVATE}_${PrefCategoryConst.INTERNAL}`, label: '相対 - 県内' },
  // { value: `${ListingCategoryConst.PRIVATE}_${PrefCategoryConst.EXTERNAL}`, label: '相対 - 県外' },
  { value: `${ListingCategoryConst.BIDDING}_${PrefTypeConst.INTERNAL}`, label: '通常入札 - 県内扱' },
  { value: `${ListingCategoryConst.BIDDING}_${PrefTypeConst.EXTERNAL}`, label: '通常入札 - 県外扱' },
  // { value: `${ListingCategoryConst.SALE}_${PrefCategoryConst.INTERNAL}`, label: '入札会 - 県内' },
  // { value: `${ListingCategoryConst.SALE}_${PrefCategoryConst.EXTERNAL}`, label: '入札会 - 県外' },
];

/**
 * 【共通ユーティリティ】
 * "2_1" のような文字列を分解して、数値(Number)にして返す
 */
export const parseCombinedCategory = (value: string) => {
  if (!value) return { listingCategory: undefined, prefCategory: undefined };
  const [listingCatStr, prefCatStr] = value.split("_");
  return {
    // Number() を使って数値に変換する
    listingCategory: listingCatStr ? Number(listingCatStr) : undefined,
    prefCategory: prefCatStr ? Number(prefCatStr) : undefined,
  };
};